import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'

const ESCAPE_KEY = 27

export class PreviewItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      saveChanges: false,
      waitingOnSave: false
    }
  }

  listenForEsc () {
    window.removeEventListener('keyup', this.keyedUp)
    window.addEventListener('keyup', this.keyedUp)
  }

  keyedUp = evt => {
    if (evt.keyCode === ESCAPE_KEY) {
      this.closeModal(true)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.modal === 'previewItem' && nextProps.modal !== 'previewItem') {
      this.closeModal()
    }
    if (this.props.modal !== 'previewItem' && nextProps.modal === 'previewItem' && nextProps.item.changes) {
      this.setState({
        saveChanges: true
      })
    }
    if (this.state.waitingOnSave && this.props.saving && !nextProps.saving) {
      this.setState({
        waitingOnSave: false,
        saveChanges: false
      })
    }
  }

  componentWillUnmount () {
    window.removeEventListener('keyup', this.keyedUp)
  }

  handlePreview = () => {
    this.openModal()
  }

  handleReload = () => {
    document.getElementById('item-preview-frame').src = document.getElementById('item-preview-frame').src
  }

  openModal = () => {
    this.listenForEsc()
    this.setState({ showModal: true })
  }

  closeModal = (backToItem = false) => {
    window.removeEventListener('keyup', this.keyedUp)
    this.setState({
      showModal: false,
      saveChanges: false,
      waitingOnSave: false
    })
    if (backToItem) {
      this.props.onClearModal()
    }
  }

  handleSave = () => {
    const { onHandleSave } = this.props
    onHandleSave()
    this.setState({
      waitingOnSave: true
    })
  }

  render () {
    let modal
    const { showModal, saveChanges } = this.state
    const { app: { primaryColor, previewUrl }, saving, templates: { selected } } = this.props

    let disabled
    if (saving) {
      disabled = 'disabledBtn'
    }

    if (saveChanges) {
      modal = (
        <div className={css.bg}>
          <article className={`${css.wrapper} ${this.props.app.standAloneMode ? css.wrapperStandAlone : ''}`}>
            <header className={css.header}>
              <h3 className={css.h3}>
                Save changes before previewing?
              </h3>
            </header>
            <div className={css.content}>
              <button onClick={this.handleSave} className={`${css.bottomBtn} ${css[disabled]}`}>Yes</button>
              <button onClick={() => this.setState({ saveChanges: false })} className={`${css.bottomBtn} ${css[disabled]}`}>No</button>
            </div>
          </article>
        </div>
      )
    } else if (showModal) {
      modal = (
        <div className={css.bg}>
          <article className={`${css.wrapper} ${this.props.app.standAloneMode ? css.wrapperStandAlone : ''}`}>
            <header className={css.header}>
              <h3 className={css.h3}>
                Preview Item
                <button className={css.reload} onClick={this.handleReload}>
                  Reload Preview
                </button>
              </h3>
              <h4 className={css.h4} style={{ color: primaryColor }}>
                {this.props.item.schema.stem.templates[0]}
              </h4>
            </header>
            <div className={css.content}>
              <iframe src={previewUrl} className={css.frame} id='item-preview-frame' />
            </div>
          </article>
        </div>
      )
    }

    return (
      <div className={css.Preview}>
        <button
          type='button'
          className={`${css.btn} ${this.props.modal === 'previewItem' ? css.currentTab : null}`}
          onClick={this.handlePreview}
          style={{ background: this.props.modal === 'previewItem' ? primaryColor : null, display: selected.length ? 'block' : 'none' }}
          data-modal='previewItem'
        >
          Preview Item
        </button>
        {modal}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, item, templates } = state
  return {
    app,
    item,
    templates
  }
}

export default connect(mapStateToProps)(PreviewItem)



// WEBPACK FOOTER //
// /app/js/components/PreviewItem/index.js